module.exports = __webpack_public_path__ + "static/media/key.6faa02d4.svg";